<template lang='pug'>
  include /mixins.pug
  +b.modal
    +b.close(@click.prevent="$emit('close')")
      +b.I.icon.--type_close
    +e.P.title.--ta_center {{ title }}
</template>

<script>
export default {
  name: 'MessageModal',
  props: {
    title: {},
    success: {},
  },
}
</script>
